import {refugiosService} from "@/data";


const state = () => ({
    geoJson: null
});

const getters = {

}

const actions = {
    getAllRutas({commit}) {
        refugiosService.getAllRoutes().then(data => {
            commit('setRutas', data)
        })
    }
}

const mutations = {
    setRutas(state, rutas) {
        state.geoJson = rutas
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}